enum EditorMode {
  ReadOnly = 'readOnly',
  Checkout = 'checkout',
  CheckedOut = 'checkedOut',
  Standard = 'standard',
}

export { EditorMode };
